import * as types from '../mutation-types'
import api from '@/api/quiz'

// initial state
const state = {
    quiz: [],
    quiz_answers: {},
    loaded: false,
}

const getters = {
    quiz: state => state.quiz,
    quizLoaded: state => state.loaded,
    quizAnswers: state => state.quiz_answers,
}

const actions = {
    getQuiz({ commit }, id) {
        commit(types.SET_QUIZ_LOADED, false );
        api.getQuiz(id, {_embed: 1},(response) => {
            commit(types.SET_QUIZ, response._embedded.Quiz );
            commit(types.SET_QUIZ_LOADED, true );
        })
    },
    setQuizAnswers({ commit }, payload)  {
        commit(types.SET_QUIZ_ANSWERS, payload );
    },
    cleanQuizAnswers({ commit })  {
        commit(types.SET_QUIZ_ANSWERS, null );
    },
}

const mutations = {
    [types.SET_QUIZ] (state, quiz ) {
        state.quiz = quiz
    },
    [types.SET_QUIZ_LOADED] (state, status ) {
        state.loaded = status
    },
    [types.SET_QUIZ_ANSWERS] (state, payload ) {
        if(!payload) {
            state.quiz_answers = {}
            return
        }
        state.quiz_answers = {...state.quiz_answers, ...payload}
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


